/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DisplayCondition } from './DisplayCondition';
import {
    DisplayConditionFromJSON,
    DisplayConditionFromJSONTyped,
    DisplayConditionToJSON,
} from './DisplayCondition';
import type { Field } from './Field';
import {
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
} from './Field';

/**
 * 
 * @export
 * @interface ControlQuestionDefinition
 */
export interface ControlQuestionDefinition {
    /**
     * 
     * @type {string}
     * @memberof ControlQuestionDefinition
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlQuestionDefinition
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ControlQuestionDefinition
     */
    short_description?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlQuestionDefinition
     */
    long_description?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlQuestionDefinition
     */
    category_id: string;
    /**
     * 
     * @type {Field}
     * @memberof ControlQuestionDefinition
     */
    field?: Field;
    /**
     * 
     * @type {boolean}
     * @memberof ControlQuestionDefinition
     */
    allow_evidence?: boolean;
    /**
     * 
     * @type {DisplayCondition}
     * @memberof ControlQuestionDefinition
     */
    display_condition?: DisplayCondition;
    /**
     * 
     * @type {boolean}
     * @memberof ControlQuestionDefinition
     */
    optional?: boolean;
}

/**
 * Check if a given object implements the ControlQuestionDefinition interface.
 */
export function instanceOfControlQuestionDefinition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "category_id" in value;

    return isInstance;
}

export function ControlQuestionDefinitionFromJSON(json: any): ControlQuestionDefinition {
    return ControlQuestionDefinitionFromJSONTyped(json, false);
}

export function ControlQuestionDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlQuestionDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'short_description': !exists(json, 'short_description') ? undefined : json['short_description'],
        'long_description': !exists(json, 'long_description') ? undefined : json['long_description'],
        'category_id': json['category_id'],
        'field': !exists(json, 'field') ? undefined : FieldFromJSON(json['field']),
        'allow_evidence': !exists(json, 'allow_evidence') ? undefined : json['allow_evidence'],
        'display_condition': !exists(json, 'display_condition') ? undefined : DisplayConditionFromJSON(json['display_condition']),
        'optional': !exists(json, 'optional') ? undefined : json['optional'],
    };
}

export function ControlQuestionDefinitionToJSON(value?: ControlQuestionDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'short_description': value.short_description,
        'long_description': value.long_description,
        'category_id': value.category_id,
        'field': FieldToJSON(value.field),
        'allow_evidence': value.allow_evidence,
        'display_condition': DisplayConditionToJSON(value.display_condition),
        'optional': value.optional,
    };
}

